// @flow

import React from 'react';
import injectL10n from 'react-aaui/lib/shared/injectL10n';
import escape from 'lodash/fp/escape';
import type { L10n } from 'type/type';

type Props = {
  category: string,
  l10n: L10n
}

export const Result = ({
  category,
  l10n: {
    formatMessage,
  },
}: Props) => {
  const key = 'page.event.virtualEvent.submitResult.result.success.message';
  const message = formatMessage(key, [ escape(category) ]);

  return (
    <div className="virtual-event__submit-result__result">
      <div className="virtual-event__submit-result__result__success-icon" />
      <p
        className="virtual-event__submit-result__result__success-message"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: message }} />
    </div>
  );
};

export default injectL10n()(Result);
